import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  descargarAuditoriaCambiosCsv,
  descargarAuditoriaDocumentosCsv,
  listarAuditoriaCambios,
  listarAuditoriaDocumentos,
  type AuditoriaCambiosPaginadoFiltros,
  type AuditoriaDocumentosFiltros,
  type AuditoriaDocumentosPaginadoFiltros,
  type AuditoriaFiltros,
} from "../services/auditoria-service";

/**
 * Listados PAGINADOS server-side · los filtros (incluida la página) forman
 * parte de la key. `keepPreviousData` evita el parpadeo al cambiar de
 * filtro/página. Sin `useSuspenseQuery`: la sección tiene su propio
 * empty-state y no necesita Suspense boundary.
 */
export function useAuditoriaCambios(filtros: AuditoriaCambiosPaginadoFiltros) {
  return useQuery({
    queryKey: [...qk.auditoriaCambios, "paginado", filtros],
    queryFn: () => listarAuditoriaCambios(filtros),
    placeholderData: keepPreviousData,
  });
}

export function useAuditoriaDocumentos(filtros: AuditoriaDocumentosPaginadoFiltros) {
  return useQuery({
    queryKey: [...qk.auditoriaDocumentos, "paginado", filtros],
    queryFn: () => listarAuditoriaDocumentos(filtros),
    placeholderData: keepPreviousData,
  });
}

export function useExportarCambiosCsv() {
  return useMutation({
    mutationFn: (filtros: AuditoriaFiltros) => descargarAuditoriaCambiosCsv(filtros),
    onSuccess: () => toastExito({ title: "Descarga lista", message: "CSV descargado." }),
    onError: toastErrorApi,
  });
}

export function useExportarDocumentosCsv() {
  return useMutation({
    mutationFn: (filtros: AuditoriaDocumentosFiltros) =>
      descargarAuditoriaDocumentosCsv(filtros),
    onSuccess: () => toastExito({ title: "Descarga lista", message: "CSV descargado." }),
    onError: toastErrorApi,
  });
}
